import * as React from "react";
import type { SVGProps } from "react";
const SvgStopCircleContained = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M2.3999 11.9999C2.3999 6.69797 6.69797 2.3999 11.9999 2.3999C17.3018 2.3999 21.5999 6.69797 21.5999 11.9999C21.5999 17.3018 17.3018 21.5999 11.9999 21.5999C6.69797 21.5999 2.3999 17.3018 2.3999 11.9999Z"
    />
    <path
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M8.3999 9.7499C8.3999 9.00432 9.00432 8.3999 9.7499 8.3999H14.2499C14.9955 8.3999 15.5999 9.00432 15.5999 9.7499V14.2499C15.5999 14.9955 14.9955 15.5999 14.2499 15.5999H9.7499C9.00432 15.5999 8.3999 14.9955 8.3999 14.2499V9.7499Z"
    />
  </svg>
);
export default SvgStopCircleContained;
